import React, { PropsWithChildren, useEffect, useState } from "react"
import { DocumentGridStateType, ISaveFocus } from "../../@types/documents"
import { DocumentStatusType, IdTableVariant, RequestState, SysOptionName } from "../../@types/enumsGlobal"
import { IKeyValuePair } from "../../Business/Reports/Shared/Interfaces/IKeyValuePair"
import { IJson } from "../../Business/Service/SysOptions/components/interface"
import { DocumentsFilteringPanelV2 } from "../../hoc/DocumentsFilteringPanelV2/DocumentsFilteringPanelV2"
import { RequestStatePanel } from "../../hoc/RequestStatePanel/RequestStatePanel"
import { DocumentDataProviderV2 } from "../../Services/DataProviders/Common/DocumentDataProviderV2"
import { SysOptionsDataProvider } from "../../Services/DataProviders/SysOptionsDataProvider"
import { DefaultDatePeriod, GridFilterAction } from "../../system/hooks/useGridFilter"
import { useAppContext } from "../../system/providers/appContextProvider"
import { useTabsContext } from "../../system/providers/tabsProvider"
import { useUserContext } from "../../system/providers/userContextProvider"
import { IDatePeriod } from "../datePeriodPicker/datePeriodPicker"
import { IItem } from "../dropDown/ButtonDropDown"
import useLockingDocuments from "../lockDocuments/useLockingDocuments"
import { CancelModalWindow } from "../modalWindows/CancelModalWindow"
import { DeleteModalWindow } from "../modalWindows/DeleteModalWindow"
import { ProcessModalWindow } from "../modalWindows/ProcessModalWindow"
import { RestoreModalWindow } from "../modalWindows/RestoreModalWindow"
import { UnprocessModalWindow } from "../modalWindows/UnprocessModalWindow"
import { IOption } from "../selects/select"
import DocumentsCommandsPanel from "./DocumentsCommandsPanel"
import { useSearchDocument } from "./documentSearchPanel"
import { DocumentSearchPanelAntd } from "./documentSearchPanel/components/DocumetnSearchPanelAntd"
import styles from "./styles/BaseCommandsPanelV3.module.scss"
import SearchModalWindowAntd from "../modalWindows/SearchModalWindowAntd/SearchModalWindowAntd"
import { v4 as uuidv4 } from "uuid"


export type DateType = "date" | "documentDate" | "dateCreated"

interface IDefaultDocumentsPanelProps<TDocumentViewDtoPagenatedView, TDocumentGetDTO, TDocumentCreateDTO, IDocumentUpdateDTO, TDocumentItemViewDtoPagenatedView, TDocumentItemGetDTO> {
    selectedItem?: [IGridRow | undefined, (value: IGridRow | undefined) => void]
    selectedItems: [IGridRow[] | [], (value: IGridRow[] | []) => void]
    saveFocus: [ISaveFocus, (value: ISaveFocus) => void];
    gridFilter?: [IGridFilter, React.Dispatch<GridFilterAction>]
    documentStatusType: [DocumentStatusType | undefined, (value: DocumentStatusType | undefined) => void]
    selectedDocumentStatusType: [DocumentStatusType | undefined, (value: DocumentStatusType | undefined) => void];
    multipleSelect?: [boolean, React.Dispatch<React.SetStateAction<boolean>>]
    dataProvider: DocumentDataProviderV2<TDocumentViewDtoPagenatedView, TDocumentGetDTO, TDocumentCreateDTO, IDocumentUpdateDTO, TDocumentItemViewDtoPagenatedView, TDocumentItemGetDTO>
    pluginSettings: IPluginSettings
    plugin: IPlugin
    idTable?: IdTableVariant
    setViewState?: (viewState: DocumentGridStateType) => void
    dateType?: DateType
    advancedFeatures?: boolean
    items?: IItem[]
    exportTools?: IItem[];
    exportView?: () => void,
    impossibilityAction?: { impossibilityProcess: boolean }
    mnemocode: string | undefined
    processDisabled?: boolean
    unProcessDisabled?: boolean
    processFinallyHandle?: (idDocumentGlobal: string) => void
    unprocessFinallyHandle?: (idDocumentGlobal: string) => void
    checkLockingDocuments?: boolean
    isCancelVisible?: boolean
    isConfirmVisible?: boolean
    isConfirmDeductionVisible?: boolean
    isCrosspharmacy?: boolean
    isContractorUserSender?: boolean
    isValidateProc?: (callback: (result: boolean) => void) => void
    requestDoValidationSuccessedAlready?: () => boolean
    initStateForValidate?: () => void
    optionsForSearchPanel?: IOption[]
    isRequestStatePanelVisible?: boolean
    requestState?: RequestState | undefined
    onRequestStateChange?: (state: RequestState | undefined) => void
    onCreateMovement?: () => void;
    isCreateMovementVisible?: boolean
    hasOwnContractor?: boolean
    unProcessIsHide?: boolean;
    processPreliminaryHandleWithConfirmation?: (idDocumentGlobal: string, sendData: () => void) => void;
}
function checkDocumentStateForMultipleChoice(arr: IGridRow[] | []) {
    if (arr.length === 0) {
        return true
    }
    return !arr.every((object) => {
        const documentStateCell = object.cells.find((cell) => cell.propertyName === "documentState")
        return documentStateCell && documentStateCell.value === "draft"
    })
}

function checkDocumentStateForMultipleChoiceRestore(arr: IGridRow[] | []): boolean {
    if (arr.length === 0) {
        return true
    }
    return !arr.every((object) => {
        return object.isDeleted
    })
}

const DefaultDocumentsCommandsPanelV3 = <TDocumentViewDtoPagenatedView, TDocumentGetDTO, TDocumentCreateDTO, IDocumentUpdateDTO, TDocumentItemViewDtoPagenatedView, TDocumentItemGetDTO>(
    props: PropsWithChildren<
        IDefaultDocumentsPanelProps<TDocumentViewDtoPagenatedView, TDocumentGetDTO, TDocumentCreateDTO, IDocumentUpdateDTO, TDocumentItemViewDtoPagenatedView, TDocumentItemGetDTO>
    >
) => {
    const appContext = useAppContext()
    const tabsContext = useTabsContext()
    const userContext = useUserContext()
    const sysOptionsDataProvider = new SysOptionsDataProvider(appContext.coreApiService)
    const [datePeriod, setDatePeriod] = useState<IDatePeriod>(DefaultDatePeriod)
    const [viewState, setViewState] = useState<DocumentGridStateType>("view")
    const [modalWindow, setModalWindow] = useState(<></>)
    const [isSearchModalVisible, setIsSearchModalVisible] = useState(false);
    const [stateNotice, setStateNotice] = useState<boolean>(false)
    const permisionUnProcessHard = userContext.userPermission.find((c) => c === "UnProcessHard.FullAccess")
    const { getSearchValue } = useSearchDocument({ gridFilter: props.gridFilter?.[0]!, dispatchGridFilter: props.gridFilter?.[1]! })
    const lockingDocuments = useLockingDocuments()

    useEffect(() => {
        if (viewState === "refresh" || viewState === "view") {
            sysOptionsDataProvider.getByName(SysOptionName.StateNotice, (data) => {
                if (!data) return
                let obj: IJson = JSON.parse(data.jsonData)
                if (!obj) return
                if (obj.Value === undefined) return
                setStateNotice(Boolean(obj.Value))
            })
        }
    }, [viewState])

    useEffect(() => {
        if (viewState === "refresh") {
            refreshDocument()
        } else {
            renderModalWindow()
        }
    }, [viewState])
    
    const dispatchFilter = (dispatchGridFilter: (data: GridFilterAction) => void, datePeriod?: IDatePeriod, documentState?: DocumentStatusType) => {

        const existingFilters = props.gridFilter?.[0]?.columnFilters?.filter(filter => {
            const isDateField = props.pluginSettings?.columns.some(c =>
                c.propertyName === filter.name &&
                (c.propertyType === "date" || c.propertyType === "datetime")
            );
            const isStatusField = filter.name === "documentState";
            return !isDateField && !isStatusField;
        }) || [];

        dispatchGridFilter({
            type: "sortByFilters",
            payload: {
                gridColumnFilter: [
                    ...existingFilters,
                    ...(datePeriod?.startDate
                        ? [
                            {
                                name: props.dateType ?? "documentDate",
                                value: datePeriod.startDate.toFormat("yyyyMMdd"),
                                operator: "MoreOrEq",
                            } as IGridColumnFilter,
                        ]
                        : []),
                    ...(datePeriod?.endDate
                        ? [
                            {
                                name: props.dateType ?? "documentDate",
                                value: datePeriod.endDate.toFormat("yyyyMMdd"),
                                operator: "LessOrEq",
                            } as IGridColumnFilter,
                        ]
                        : []),
                    ...(documentState
                        ? [
                            {
                                name: "documentState",
                                value: documentState,
                                operator: "Eq",
                            } as IGridColumnFilter,
                        ]
                        : []),
                ],
            },
        })
    }

    function refreshDocument() {
        props.setViewState?.("refresh")
        dispatchFilter(() => props.gridFilter?.[1], datePeriod, undefined)
        setViewState("view")
    }

    function renderModalWindow() {
        switch (viewState) {
            case "process":
                renderProcessModalWindow()
                break
            case "unprocess":
                renderUnprocessModalWindow()
                break
            case "unprocessHard":
                renderUnprocessHardModalWindow()
                break
            case "delete":
                renderDeleteModalWindow()
                break
            case "restore":
                renderRestoreModalWindow()
                break
            case "restoreAll":
                renderRestoreModalWindow()
                break
            case "search":
                renderSearchWindow()
                break
            case "cancel":
                renderCancelWindow()
                break
            default:
                setModalWindow(<></>)
                break
        }
    }

    const isValidateProc = (callback: (result: boolean) => void) => {
        if (!props.isValidateProc) callback(true)
        props?.isValidateProc?.((result) => {
            callback(result)
        })
    }

    const hasActiveFilters = () => {
        if (!props.gridFilter?.[0]?.columnFilters) return false;

        return props.gridFilter[0].columnFilters.some(filter => {
            const isDateField = props.pluginSettings?.columns.some(c =>
                c.propertyName === filter.name &&
                (c.propertyType === "date" || c.propertyType === "datetime")
            );
            const isProtectedOperator = filter.operator === "MoreOrEq" || filter.operator === "LessOrEq";
            const isProtected = isDateField && isProtectedOperator;

            return !isProtected;
        });
    };

    function renderProcessModalWindow() {

        const provideProcess = () => {

            if (props.selectedItems[0].length > 0) {
                const promises = new Array<() => Promise<any>>();
                props.selectedItems[0].forEach(async (element) => {
                    const procPromise = () => {
                        return new Promise((resolve, reject) => {
                            lockingDocuments.check(element?.idGlobal as string, (e) => {
                                if (!e) {
                                    props.dataProvider?.process(element.idGlobal as string, (e) => {
                                        if (e.respType === 'isCompleted') {
                                            props?.saveFocus[1]?.({ ...props?.saveFocus as any, viewState: 'process' });
                                            props.processFinallyHandle?.(element.idGlobal);
                                            resolve(true);
                                        } else {
                                            setViewState('return');
                                            resolve(false);
                                        };
                                    });
                                } else resolve(false)
                            })
                        });
                    }

                    promises.push(procPromise);
                });

                promises.reduce((chain, f) =>
                    chain.then(f), Promise.resolve());
            } else {
                lockingDocuments.check(props.selectedItem?.[0]?.idGlobal as string, (e) => {
                    if (!e) {
                        props.dataProvider?.process(props.selectedItem?.[0]?.idGlobal as string, (e) => {
                            if (e.respType === 'isCompleted') {
                                props?.saveFocus[1]?.({ ...props?.saveFocus as any, viewState: 'process' });
                                props.processFinallyHandle?.(props.selectedItem?.[0]?.idGlobal as string);
                            } else setViewState('return')
                        });
                    }
                })

            }
        }

        const sendData = () => {
            isValidateProc((result) => {
                if (result === false) {
                    setViewState('return')
                    return
                }

                provideProcess();
            })
        }

        if (stateNotice === false) {
            // Проверка с подтверждением для случая БЕЗ множественной отработки
            if (props.processPreliminaryHandleWithConfirmation && props.selectedItems[0].length === 0) {

                const idDocumentGlobal = props.selectedItem?.[0]?.idGlobal as string;
                props.processPreliminaryHandleWithConfirmation(idDocumentGlobal, sendData);
            } else {

                sendData()
            }

            return
        }

        setModalWindow(
            <ProcessModalWindow
                name={props.multipleSelect?.[0] ? "many_docs" : ""}
                header={props.selectedItem?.[0] ? props.selectedItem?.[0]?.displayName : (props.multipleSelect?.[0] ? "Групповая отработка" : "")}
                cancel={() => {
                    if (props.initStateForValidate) {
                        props.initStateForValidate();
                    }
                    setViewState('return');
                }}
                process={() => {
                    //sendData();
                    //setViewState('return');
                    
                    // Вызов process (отработки документа) должен происходить 1 раз
                    // непосредственно он вызывается в provideProcess
                    // так же через sendData
                    if (props.requestDoValidationSuccessedAlready) {
                        if (props.requestDoValidationSuccessedAlready()) {
                            
                            provideProcess();
                            setViewState('return');
                        }
                        else {
                            setViewState('return');
                        };
                    }
                    else {
                        if (props.processPreliminaryHandleWithConfirmation && props.selectedItems[0].length === 0) {

                            const idDocumentGlobal = props.selectedItem?.[0]?.idGlobal as string;
                            props.processPreliminaryHandleWithConfirmation(idDocumentGlobal, sendData);
                            setViewState('return');
                        } else {

                            sendData()
                            setViewState('return');
                        }
                    }

                }}
            />
        );
    }


    function renderUnprocessHardModalWindow() {

        const sendData = () => {
            lockingDocuments.check(props.selectedItem?.[0]?.idGlobal as string, (e) => {
                if (!e) {
                    props.dataProvider?.unProcessHard(props.selectedItem?.[0]?.idGlobal as string, (e) => {
                        if (e.respType === 'isCompleted') props?.saveFocus[1]?.({ ...props?.saveFocus as any, viewState: 'unprocess' });
                        else setViewState('return')
                    })
                }
            })
        }

        if (stateNotice === false) {
            sendData()
            return
        }

        setModalWindow(
            <UnprocessModalWindow
                name={props.selectedItem?.[0]?.cells['name'] as string}
                header={props.selectedItem?.[0]?.displayName}
                cancel={() => {
                    setViewState('return');
                }}
                unprocess={() => {
                    sendData();
                    setViewState('return');
                }}
            />
        );
    }

    function renderUnprocessModalWindow() {

        const sendData = () => {
            lockingDocuments.check(props.selectedItem?.[0]?.idGlobal as string, (e) => {
                if (!e) {
                    props.dataProvider?.unProcess(props.selectedItem?.[0]?.idGlobal as string, (e) => {
                        if (e.respType === 'isCompleted') {
                            props?.saveFocus[1]?.({ ...props?.saveFocus as any, viewState: 'unprocess' });
                            props.unprocessFinallyHandle?.(props.selectedItem?.[0]?.idGlobal as string);
                        } else setViewState('return')
                    })
                }
            })
        }

        if (stateNotice === false) {
            sendData()
            return
        }

        setModalWindow(
            <UnprocessModalWindow
                name={props.selectedItem?.[0]?.cells['name'] as string}
                header={props.selectedItem?.[0]?.displayName}
                cancel={() => {
                    setViewState('return');
                }}
                unprocess={() => {
                    sendData();
                    setViewState('return');
                }}
            />
        );
    }

    function renderDeleteModalWindow() {
        const sendData = () => {
            if (props.selectedItems[0].length > 0) {
                props.selectedItems[0].forEach((element) => {
                    lockingDocuments.check(element?.idGlobal as string, (e) => {
                        if (!e) {
                            props.dataProvider?.markDelete(element.idGlobal as string, (e) => {
                                if (e.respType === 'isCompleted') props?.saveFocus[1]?.({ ...props?.saveFocus as any, viewState: 'delete' });
                                else setViewState('return')
                            });
                            props.selectedItems?.[1]([]);
                        }
                    })
                })
            } else {
                lockingDocuments.check(props.selectedItem?.[0]?.idGlobal as string, (e) => {
                    if (!e) {
                        props.dataProvider?.markDelete(props.selectedItem?.[0]?.idGlobal as string, (e) => {
                            if (e.respType === 'isCompleted') props?.saveFocus[1]?.({ ...props?.saveFocus as any, viewState: 'delete' });
                            else setViewState('return')
                        });
                    }
                })
            }
        }

        if (stateNotice === false) {
            sendData()
            return
        }

        setModalWindow(
            <DeleteModalWindow
                name={props.selectedItem?.[0]?.cells['name'] as string}
                header={props.selectedItem?.[0]?.displayName}
                cancel={{
                    onClick: () => {
                        setViewState('return');
                    },
                }}
                delete={{
                    onClick: () => {
                        sendData();
                        setViewState('return');
                    },
                    title: 'Удалить',
                }}
            />
        );
    }

    function renderRestoreModalWindow() {
        const sendData = () => {
            props.dataProvider?.restore(props.selectedItem?.[0]?.idGlobal as string, (e) => {
                if (e.respType === "isCompleted") setViewState("refresh")
                else setViewState("return")
            })
        }
        function sendDataAll() {
            props.selectedItems[0].forEach((element) => {
                props.dataProvider?.restore(element.idGlobal as string, (e) => {
                    if (e.respType === "isCompleted") {
                        setViewState("refresh")
                    } else setViewState("return")
                })
            })
        }

        if (stateNotice === false) {
            sendData()
            return
        }

        setModalWindow(
            <RestoreModalWindow
                name={viewState === "restoreAll" ? "" : (props.selectedItem?.[0]?.cells["name"] as string)}
                header={viewState === "restoreAll" ? "" : props.selectedItem?.[0]?.displayName}
                cancel={{
                    onClick: () => {
                        setViewState("return")
                    },
                }}
                restore={{
                    onClick: () => {
                        viewState === "restoreAll" ? sendDataAll() : sendData()
                    },
                    title: "Восстановить",
                }}
            />
        )
    }

    function renderSearchWindow() {

        const visibleColumns = props.pluginSettings?.columns.filter((x) => x.visibility === true) ?? [];

        const handleApplyFilters = (columnFilters: IGridColumnFilter[]) => {
            props.gridFilter?.[1]({
                type: "search",
                payload: columnFilters
            });

            props.selectedItem?.[1](undefined);

            setIsSearchModalVisible(false);
            setViewState("refresh");
        };

        const handleCancel = () => {
            setIsSearchModalVisible(false);
            setViewState("return");
        };

        setModalWindow(
            <SearchModalWindowAntd
                columns={visibleColumns}
                defaultFilters={props.gridFilter?.[0]?.columnFilters}
                search={handleApplyFilters}
                cancel={handleCancel}
                open={isSearchModalVisible}
                onCancel={handleCancel}               
            />
        );
    }

    function renderCancelWindow() {
        const sendData = () => {
            if (props.selectedItems[0].length > 0) {
                props.selectedItems[0].forEach((element) => {
                    lockingDocuments.check(element?.idGlobal as string, (e) => {
                        if (!e) {
                            props.dataProvider?.cancel(element.idGlobal as string, (e) => {
                                if (e.respType === "isCompleted") setViewState("refresh")
                                else setViewState("return")
                            })
                            props.selectedItems?.[1]([])
                        }
                    })
                })
            } else {
                lockingDocuments.check(props.selectedItem?.[0]?.idGlobal as string, (e) => {
                    if (!e) {
                        props.dataProvider?.cancel(props.selectedItem?.[0]?.idGlobal as string, (e) => {
                            if (e.respType === "isCompleted") setViewState("refresh")
                            else setViewState("return")
                        })
                        props.selectedItem?.[1](undefined)
                    }
                })
            }
        }

        if (stateNotice === false) {
            sendData()
            return
        }

        setModalWindow(
            <CancelModalWindow
                name={props.selectedItem?.[0]?.cells["name"] as string}
                header={props.selectedItem?.[0]?.displayName}
                cancel={{
                    onClick: () => {
                        setViewState("return")
                    },
                }}
                confirm={{
                    onClick: () => {
                        sendData()
                    },
                    title: "Отменить",
                }}
            />
        )
    }

    

    function openChildEdit() {
        tabsContext.openChild(
            props.plugin,
            "edit",
            props.selectedItem?.[0]?.idGlobal,
            () => {
                setViewState("refresh")
                props.selectedItem?.[1]?.(undefined)
            },
            props.mnemocode
        )
    }

    function openChildEditArray() {
        props.selectedItems[0].forEach((element) => {
            tabsContext.openChild(
                props.plugin,
                "edit",
                element.idGlobal,
                () => {
                    setViewState("refresh")
                    props.selectedItems?.[1]?.([])
                },
                element.cells.find((el) => el.propertyName === "mnemocode")?.value
            )
        })
    }

    function checkCrosspharmcyMovementForSender() {
        return props.isCrosspharmacy && props.selectedDocumentStatusType?.[0] === 'sent' && props.isContractorUserSender

    }

    function checkCrosspharmcyMovementForReceiver() {
        return props.isCrosspharmacy && props.selectedDocumentStatusType?.[0] === 'draft' && !props.isContractorUserSender
    }

    const handleCreateMovement = () => {
        if (!props.selectedItem?.[0]) return;

        const mnemocode = props.selectedItem[0].cells?.find(
            (cell) => cell.propertyName === 'mnemocode'
        )?.value as string;

        tabsContext.openChild(
            'movement_from_request_creator_plugin',
            'create',
            uuidv4(),
            () => {
                setViewState('refresh');
                props.selectedItem?.[1]?.(undefined);
            },
            { requestId: props.selectedItem[0].idGlobal, mnemocode }
        );
    };

    useEffect(() => {
        if (props.saveFocus[0]?.selectedItem)
            props.selectedDocumentStatusType?.[1](props.saveFocus[0]?.data.find(element => element.idGlobal === props.saveFocus[0]?.selectedItem?.idGlobal).documentState);
    }, [props.saveFocus[0]?.selectedItem]);

    return (
        <div className={styles.mainWrapper}>
            <div className={styles.wrapper}>
                <DocumentsCommandsPanel
                    add={{
                        onClick: () =>
                            tabsContext.openChild(props.plugin, 'create', undefined, () => {
                                setViewState('refresh');
                                props.selectedItem?.[1]?.(undefined);
                            }),
                        disabled: props.multipleSelect?.[0] === true ? props.selectedItems?.[0].length !== 0 : false
                    }}
                    edit={{
                        onClick: () => {
                            if (props.checkLockingDocuments) {
                                if (props.selectedItems[0].length > 0) {
                                    props.selectedItems[0].forEach((element) => {
                                        lockingDocuments.check(element?.idGlobal as string, (e) => {
                                            if (!e) {
                                                tabsContext.openChild(props.plugin, 'edit', element.idGlobal, () => {
                                                    props.selectedItems?.[1]?.([]);
                                                }, element.cells.find(el => el.propertyName === 'mnemocode')?.value);
                                            }
                                        })
                                    })
                                    setViewState('refresh');
                                } else {
                                    lockingDocuments.check(props.selectedItem?.[0]?.idGlobal as string, (e) => {
                                        openChildEdit();
                                    })
                                }
                            } else {
                                if (props.selectedItems[0].length > 0) {
                                    openChildEditArray();
                                } else {
                                    openChildEdit();
                                }
                            }
                        },
                        disabled:
                            props.multipleSelect?.[0] === true ? checkDocumentStateForMultipleChoice(props.selectedItems?.[0]) :
                                props.selectedItem?.[0] === undefined ||
                                props.selectedItem?.[0]?.isDeleted ||
                                props.selectedDocumentStatusType?.[0] === 'del' ||
                                props.selectedDocumentStatusType?.[0] === 'secured' ||
                                props.selectedDocumentStatusType?.[0] === 'sent',
                    }}
                    process={{
                        onClick: () => {
                            if (props.isValidateProc) {
                                props.isValidateProc((isValid) => {
                                    if (!isValid) {
                                        return;
                                    }
                                    setViewState('process');
                                });
                            } else {
                                setViewState('process');
                            }
                        },
                        disabled:
                            props.multipleSelect?.[0] === true ? checkDocumentStateForMultipleChoice(props.selectedItems?.[0]) :
                                props.selectedItem?.[0] === undefined ||
                                props.selectedDocumentStatusType?.[0] === 'new' ||
                                props.selectedDocumentStatusType?.[0] === 'proc' ||
                                props.selectedDocumentStatusType?.[0] === 'del' ||
                                props.selectedDocumentStatusType?.[0] === 'cancel' ||
                                props.selectedDocumentStatusType?.[0] === 'done' ||
                                props.selectedDocumentStatusType?.[0] === 'secured' ||
                                props.processDisabled === true ||
                                checkCrosspharmcyMovementForSender() ||
                                checkCrosspharmcyMovementForReceiver(),
                    }}
                    unProcess={{
                        onClick: () => setViewState('unprocess'),
                        disabled:
                            props.selectedItem?.[0] === undefined ||
                            props.selectedDocumentStatusType?.[0] === 'new' ||
                            props.selectedDocumentStatusType?.[0] === 'draft' ||
                            props.selectedDocumentStatusType?.[0] === 'save' ||
                            props.selectedDocumentStatusType?.[0] === 'del' ||
                            props.selectedDocumentStatusType?.[0] === 'cancel' ||
                            props.selectedDocumentStatusType?.[0] === 'done' ||
                            props.selectedDocumentStatusType?.[0] === 'secured' ||
                            //props.selectedDocumentStatusType === 'sent' ||
                            props.unProcessDisabled === true,
                    }}
                    unProcessHard={props.idTable === IdTableVariant.Invoice ? {
                        onClick: () => setViewState('unprocessHard'),
                        disabled:
                            permisionUnProcessHard === undefined ||
                            props.selectedItem?.[0] === undefined ||
                            props.selectedDocumentStatusType?.[0] === 'new' ||
                            props.selectedDocumentStatusType?.[0] === 'draft' ||
                            props.selectedDocumentStatusType?.[0] === 'save' ||
                            props.selectedDocumentStatusType?.[0] === 'del' ||
                            props.selectedDocumentStatusType?.[0] === 'cancel' ||
                            props.selectedDocumentStatusType?.[0] === 'done' ||
                            props.selectedDocumentStatusType?.[0] === 'sent' ||
                            props.unProcessDisabled === true,
                    } : undefined}
                    unProcessIsHide={props.unProcessIsHide}
                    copy={{
                        onClick: () =>
                            tabsContext.openChild(props.plugin, 'copy', props.selectedItem?.[0]?.idGlobal, () =>
                                setViewState('refresh')
                            ),
                        disabled: props.selectedItem?.[0] === undefined,
                    }}
                    print={{
                        onClick: () => {
                            return props.idTable;
                        },
                        onSubItemClick: () => {
                            let arr = new Array<IKeyValuePair>();
                            let rows: Array<IGridRow> = new Array<IGridRow>();
                            props.selectedItems?.[0].length > 0 ? rows.push(...props.selectedItems?.[0]) : rows.push(props.selectedItem?.[0] as IGridRow);
                            rows.forEach(function (row) {
                                const mnemocode = row.cells.find((e) => {
                                    return e.propertyName == 'mnemocode';
                                })?.value;
                                if (mnemocode != undefined) arr.push({ key: row.idGlobal, value: mnemocode });
                            });
                            return arr;
                        },
                        disabled: props.multipleSelect?.[0] === true && props.selectedItems?.[0].length > 0 ? false :
                            props.selectedItem?.[0] === undefined,
                    }}
                    delete={{
                        onClick: () => setViewState('delete'),
                        disabled:
                            props.multipleSelect?.[0] === true ? checkDocumentStateForMultipleChoice(props.selectedItems?.[0]) :
                                props.selectedItem?.[0] === undefined ||
                                props.selectedItem?.[0]?.isDeleted ||
                                props.selectedDocumentStatusType?.[0] === 'proc' ||
                                props.selectedDocumentStatusType?.[0] === 'cancel' ||
                                props.selectedDocumentStatusType?.[0] === 'secured' ||
                                props.selectedDocumentStatusType?.[0] === 'del'
                    }}
                    restore={{
                        onClick: () => {
                            if (props.multipleSelect?.[0] === true && props.selectedItems?.[0].length > 0) {
                                setViewState('restoreAll')
                            } else {
                                setViewState('restore')
                            }
                        },
                        disabled:
                            props.multipleSelect?.[0] === true ? checkDocumentStateForMultipleChoiceRestore(props.selectedItems?.[0]) :
                                props.selectedItem?.[0] === undefined ||
                                props.selectedDocumentStatusType?.[0] === 'new' ||
                                props.selectedDocumentStatusType?.[0] === 'draft' ||
                                props.selectedDocumentStatusType?.[0] === 'proc' ||
                                props.selectedDocumentStatusType?.[0] === 'done' ||
                                props.selectedDocumentStatusType?.[0] === 'sent' ||
                                props.selectedDocumentStatusType?.[0] === 'secured' ||
                                props.selectedDocumentStatusType?.[0] === 'save',
                    }}
                    hasActiveFilters={hasActiveFilters()}
                    search={{
                        onClick: () => {
                            if (isSearchModalVisible) {
                                setIsSearchModalVisible(false);
                                setViewState("return");
                            } else {
                                setViewState("search");
                                setIsSearchModalVisible(true);
                                renderSearchWindow();
                            }
                        },
                        disabled: props.multipleSelect?.[0] === true ? props.selectedItems?.[0].length !== 0 : false,
                    }}
                    cancel={{
                        onClick: () => setViewState('cancel'),
                        disabled:
                            props.multipleSelect?.[0] === true ? checkDocumentStateForMultipleChoice(props.selectedItems?.[0]) :
                                props.selectedItem?.[0] === undefined ||
                                props.selectedItem?.[0]?.isDeleted ||
                                props.selectedDocumentStatusType?.[0] === 'proc' ||
                                props.selectedDocumentStatusType?.[0] === 'sent' ||
                                props.selectedDocumentStatusType?.[0] === 'done',
                        isVisible: props.isCancelVisible
                    }}
                    refresh={{
                        onClick: () => {
                            refreshDocument();
                        },
                    }}
                    groupProcessing={{
                        onClick: () => {
                            props?.multipleSelect?.[1](!props?.multipleSelect?.[0]);
                        },
                        value: props?.multipleSelect?.[0],
                    }}
                    confirm={{
                        onClick: () => {
                            if (props.checkLockingDocuments) {
                                if (props.selectedItems[0].length > 0) {
                                    props.selectedItems[0].forEach((element) => {
                                        lockingDocuments.check(element?.idGlobal as string, (e) => {
                                            if (!e) {
                                                tabsContext.openChild(props.plugin, 'view', element.idGlobal, () => {
                                                    props.selectedItems?.[1]?.([]);
                                                }, element.cells.find(el => el.propertyName === 'mnemocode')?.value);
                                            }
                                        })
                                    })
                                    setViewState('refresh');
                                } else {
                                    lockingDocuments.check(props.selectedItem?.[0]?.idGlobal as string, (e) => {
                                        openChildEdit();
                                    })
                                }
                            } else {
                                if (props.selectedItems[0].length > 0) {
                                    openChildEditArray();
                                } else {
                                    openChildEdit();
                                }
                            }
                        },
                        disabled:
                            props.multipleSelect?.[0] === true ? checkDocumentStateForMultipleChoice(props.selectedItems?.[0]) :
                                props.selectedItem?.[0] === undefined ||
                                props.selectedItem?.[0]?.isDeleted ||
                                props.selectedDocumentStatusType?.[0] !== 'sent',
                        isVisible: props.isConfirmVisible
                    }}
                    confirmDeduction={{
                        onClick: () => {
                            if (props.checkLockingDocuments) {
                                if (props.selectedItems[0].length > 0) {
                                    props.selectedItems[0].forEach((element) => {
                                        lockingDocuments.check(element?.idGlobal as string, (e) => {
                                            if (!e) {
                                                tabsContext.openChild(props.plugin, 'view', element.idGlobal, () => {
                                                    props.selectedItems?.[1]?.([]);
                                                }, element.cells.find(el => el.propertyName === 'mnemocode')?.value);
                                            }
                                        })
                                    })
                                    setViewState('refresh');
                                } else {
                                    lockingDocuments.check(props.selectedItem?.[0]?.idGlobal as string, (e) => {
                                        openChildEdit();
                                    })
                                }
                            } else {
                                if (props.selectedItems[0].length > 0) {
                                    openChildEditArray();
                                } else {
                                    openChildEdit();
                                }
                            }
                        },
                        disabled:
                            props.multipleSelect?.[0] === true
                                ? checkDocumentStateForMultipleChoice(props.selectedItems?.[0])
                                : props.selectedItem?.[0] === undefined || props.selectedItem?.[0]?.isDeleted || props.selectedDocumentStatusType?.[0] !== "sent",
                        isVisible: props.isConfirmDeductionVisible,
                    }}
                   
                    createMovement={{                        
                        onClick: handleCreateMovement,
                        disabled:
                            props.selectedItem?.[0] === undefined ||
                            props.selectedDocumentStatusType?.[0] === 'secured' ||                            
                            props.selectedDocumentStatusType?.[0] !== "proc" ||
                            props.hasOwnContractor === false,
                        isVisible: props.isCreateMovementVisible                       
                    }}
                    advancedFeatures={props.advancedFeatures}
                    exportTools={props.exportTools}
                    exportView={props.exportView}
                    items={props.items}
                    permission={props.pluginSettings.permission}
                />
                <DocumentsFilteringPanelV2
                    datePeriod={datePeriod}
                    onDatePeriodChange={(date: IDatePeriod) => {
                        setDatePeriod(date)
                        props.selectedItem?.[1](undefined)
                        if (props.gridFilter?.[1]) {
                            dispatchFilter(props.gridFilter[1], date, props.documentStatusType[0])
                        }
                    }}
                    multipleSelect={props?.multipleSelect?.[0]}
                    documentStatusType={props.documentStatusType[0]}
                    onDocumentStatusTypeChange={(value) => {
                        props.selectedItem?.[1](undefined)
                        props.documentStatusType?.[1](value)
                        if (props.gridFilter?.[1]) {
                            dispatchFilter(props.gridFilter[1], datePeriod, value)
                        }
                    }}
                    onMultipleSelectChange={props?.multipleSelect?.[1]}
                />
                {props.gridFilter?.[0] && props.gridFilter?.[1] && <DocumentSearchPanelAntd onSubmit={getSearchValue} options={props.optionsForSearchPanel} selectedItem={props.selectedItem} />}
                {props.isRequestStatePanelVisible && <RequestStatePanel requestState={props.requestState} onRequestStateChange={props.onRequestStateChange} />}
                {modalWindow}
            </div>
        </div>
    )
}

export default DefaultDocumentsCommandsPanelV3
